import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "./PostHarvestManagment.css";
import Footer from "../Home/Footer";
import KeyBenefitImage1 from "../assets/img/KeyBenefitsofPostHarvestmanagement-1.jpg";
import KeyBenefitImage2 from "../assets/img/KeyBenefitsofPostHarvestmanagement-2.jpg";
import KeyBenefitImage3 from "../assets/img/KeyBenefitsofPostHarvestmanagement-3.jpg";
import KeyBenefitImage4 from "../assets/img/KeyBenefitsofPostHarvestmanagement-4.jpg";
import KeyBenefitImage5 from "../assets/img/KeyBenefitsofPostHarvestmanagement-5.jpg";
import KeyBenefitImage6 from "../assets/img/KeyBenefitsofPostHarvestmanagement-6.jpg";

const benefitsData = [
  {
    id: 1,
    image: KeyBenefitImage1,
    title: "Optimal Storage",
    description:
      "Preserve freshness and prevent spoilage with modern storage solutions.",
  },
  {
    id: 2,
    image: KeyBenefitImage6,
    title: "Efficient Processing",
    description:
      "Enhance crop value through proper drying, grading, and packaging.",
  },
  {
    id: 3,
    image: KeyBenefitImage3,
    title: "Improved Marketability",
    description: "Increase market demand with high-quality produce.",
  },
  {
    id: 4,
    image: KeyBenefitImage4,
    title: "Cold Storage",
    description:
      "Extend shelf life and reduce losses with advanced refrigeration techniques.",
  },
  {
    id: 5,
    image: KeyBenefitImage5,
    title: "Supply Chain Efficiency",
    description:
      "Ensure timely delivery and maintain product quality throughout transit.",
  },
];
const stepsData = [
  {
    id: 1,
    image: "https://source.unsplash.com/400x300/?harvest",
    icon: "🚜",
    title: "Harvesting",
    description: "Proper timing and techniques ensure high-quality produce.",
  },
  {
    id: 2,
    image: "https://source.unsplash.com/400x300/?drying",
    icon: "🌞",
    title: "Drying & Sorting",
    description: "Controlled drying and sorting maintain product quality.",
  },
  {
    id: 3,
    image: "https://source.unsplash.com/400x300/?packaging",
    icon: "📦",
    title: "Packaging & Storage",
    description: "Protect crops using modern packaging and storage methods.",
  },
  {
    id: 4,
    image: "https://source.unsplash.com/400x300/?transport",
    icon: "🚚",
    title: "Transportation",
    description: "Safe and efficient delivery maintains product freshness.",
  },
  {
    id: 5,
    image: "https://source.unsplash.com/400x300/?market",
    icon: "🏪",
    title: "Market Distribution",
    description: "Selling at the right time ensures maximum profitability.",
  },
];

const PostHarvestManagement = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false, // Ensure animations trigger every time an element enters the viewport
      mirror: true, // Repeats animation when scrolling up
      debounceDelay: 50, // Smooth animation trigger
      throttleDelay: 100,
      startEvent: "DOMContentLoaded",
      useClassNames: false,
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
    });

    // Refresh AOS when Swiper updates
    setTimeout(() => {
      AOS.refresh();
    }, 500);
  }, []);

  return (
    // <div className="post-harvest-page">
    //   {/* Hero Section */}
    //   <section className="post-hero-section">
    //     <div className="container-fluid">
    //       <div className="post-row align-items-center">
    //         <div className="col-md-6 text-content" data-aos="fade-right">
    //           <h1 style={{ color: "#d4561a" }}>
    //             Focus On <br /> What Matters
    //           </h1>
    //           <p>
    //             Efficient post-harvest handling enhances crop quality, reduces
    //             losses, and boosts profitability.
    //           </p>
    //         </div>

    //         <div className="col-md-6 hero-image" data-aos="fade-left">
    //           <img
    //             src={KeyBenefitImage2}
    //             alt="Post-Harvest Management"
    //             className="img-fluid"
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </section>

    //   <section className="benefits-section">
    //     <div className="container text-center">
    //       <h2>Key Benefits of Post-Harvest Management</h2>
    //       <Swiper
    //         spaceBetween={20}
    //         loop={true}
    //         autoplay={{ delay: 2000, disableOnInteraction: false }}
    //         pagination={{ clickable: true }}
    //         modules={[Pagination, Autoplay]}
    //         className="benefits-slider"
    //         breakpoints={{
    //           0: {
    //             slidesPerView: 1.1,
    //           },
    //           480: {
    //             slidesPerView: 1.5,
    //           },
    //           768: {
    //             slidesPerView: 2.5,
    //           },
    //           1024: {
    //             slidesPerView: 3.5,
    //           },
    //         }}
    //       >
    //         {benefitsData.map((benefit) => (
    //           <SwiperSlide key={benefit.id} className="benefit-card">
    //             <div className="card" data-aos="fade-up">
    //               <img
    //                 src={benefit.image}
    //                 alt={benefit.title}
    //                 className="card-img-top"
    //                 data-aos="zoom-in"
    //                 style={{
    //                   height: "200px",
    //                   objectFit: "cover",
    //                 }}
    //               />
    //               <div className="card-body">
    //                 <h3 className="card-title">{benefit.title}</h3>
    //                 <p className="card-text">{benefit.description}</p>
    //               </div>
    //             </div>
    //           </SwiperSlide>
    //         ))}
    //       </Swiper>
    //     </div>
    //   </section>

    //   <section className="how-it-works-section">
    //     <div className="container">
    //       <h2 className="text-center" style={{ color: "#d4561a" }}>
    //         How Post-Harvest Works
    //       </h2>
    //       <div className="steps-container">
    //         {stepsData.map((step) => (
    //           <div key={step.id} className="step-card" data-aos="fade-up">
    //             <div className="card-inner">
    //               <div
    //                 className="card-front"
    //                 style={{ backgroundImage: `url(${step.image})` }}
    //               >
    //                 <div className="overlay">
    //                   <div className="step-icon">{step.icon}</div>
    //                   <h3>{step.title}</h3>
    //                 </div>
    //               </div>
    //               <div className="card-back">
    //                 <div className="step-icon">{step.icon}</div>
    //                 <p>{step.description}</p>
    //               </div>
    //             </div>
    //           </div>
    //         ))}
    //       </div>
    //     </div>
    //   </section>

    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostHarvestManagement;
